//@flow
import * as React from 'react'

export type WaitWithNote$Props = {
    waitNote:any
}

const WaitWithNote=(props:WaitWithNote$Props)=>{
    return (
        <div className="container">
            <div className='row'>
            <br />
            </div>   
            <div className="row">
                {props.waitNote}
            </div>
        </div>
    )
}

export default WaitWithNote


// WEBPACK FOOTER //
// ./src/views/common/WaitWithNote.js